import React, { useCallback, useMemo } from 'react';
import { Link } from 'react-router-dom';
import getProductDescription from '../helpers/getProductDescription';
import BsTag from '../icons/BsTag';
import getSymbolFromCurrency from 'currency-symbol-map';
import { any, array, func, number, oneOfType, string } from 'prop-types';
import ResponsiveImage from './ResponsiveImage';
import { useContext } from 'react';
import AppContext from './context/AppContext';
import constants from '../constants.json' assert { type: 'json' };
import useDynamicPath from '../hooks/useDynamicPath';

export default function SearchResultsItemProduct({ query, title, descriptionHtml, handle, price, imageUrl, onClick = () => {}, variants, sku }) {
    const { appContext } = useContext(AppContext);
    const productPath = useDynamicPath({ pathName: constants.DYNAMIC_PATHS.PRODUCT_PATH });
    const appConfig = appContext.config.themeConfig;

    const handleMatched = (handle, query) => {
        return query.replace(/[^0-9-]/g, '') === handle.replace(/[^0-9-]/g, '');
    };

    const highlight = useCallback(word => {
        if (!query) {
            return false;
        }

        return query.toLowerCase().split(' ').some(element => {
            if (element === '') {
                return false;
            }

            return word.toLowerCase().includes(element);
        });
    }, [query]);

    const skuToDisplay = useMemo(() => {
        return  sku ?? variants.find(variant => variant.sku !== null)?.sku;
    }, [sku]);

    return (<li>
        <Link
            onClick={onClick}
            className={'search--results-item search--results-item-link'}
            to={`${productPath[0].pathBeforeParams}/${handle}`}>
            {imageUrl && (<ResponsiveImage
                className={'search--results-item-image me-2'}
                imageUrl={imageUrl}
                imageAlt={''}
                mobileSize={'200px'}
                desktopSize={'200px'}></ResponsiveImage>)}
            {!imageUrl && (<span
                className={'me-2'}><BsTag
                    size={'25px'} /></span>
            )}
            <div
                className={`search--results-item--inner ${handleMatched(handle,query) ? 'fw-bold' : ''}`}>
                {title?.length > 0 && (<p
                    className={'search--results-item-title'}>{title.split(' ').map((word, i) => {
                        return (
                            <>
                                <span
                                    className={ highlight(word) ? 'highlight' : ''}
                                    key={i}
                                >
                                    {word}
                                </span>{' '}
                            </>
                        );
                    })}</p>)}
                {!!skuToDisplay && (<p
                    className={'search--results-item-sku'}>{skuToDisplay}</p>)}
                {descriptionHtml?.length > 0 && (<p
                    className={'search--results-item-description'}>{getProductDescription(descriptionHtml)}</p>)}
                {!isNaN(price) && (<p
                    className={'search--results-item-price'}>{getSymbolFromCurrency(appConfig.storeCurrency)}{price} {appConfig.storeCurrency}</p>)}
            </div>
        </Link>
    </li>);
}

SearchResultsItemProduct.propTypes = {
    title: string,
    descriptionHtml: any,
    handle: string,
    price: oneOfType([string, number]),
    imageUrl: any,
    onClick: func,
    query: string,
    variants: array,
    sku: string,
};